export default "__VITE_PUBLIC_ASSET__994e1288__"